import styled from 'styled-components';
import {Color} from '../tokens/colors';
import {Transition} from '../tokens/transitions';
import {Radius} from '../tokens/radiuses';
import {Shadow} from '../tokens/shadows';

const StyledModal = styled.div`
    z-index: 2000;
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${Color.OVERLAY_GRAY};
    animation-name: appear;
    animation-duration: 150ms;

    @keyframes appear {
        from {
            opacity: 0;
        }
        to {
            opacity: 1;
        }
    }
`;

const StyledModalDialog = styled.div`
    width: 90%;
    max-width: 358px;
    background-color: ${Color.WHITE};
    border-radius: ${Radius.BLOCK};
    box-shadow: ${Shadow.BLOCK};
`;

const StyledModalHeader = styled.div`
    position: relative;
    padding: 24px 38px;
    font-weight: 600;
    font-size: 18px;
    line-height: 1.3;
    text-align: center;
    color: ${Color.WHITE};
    background-color: ${Color.PRIMARY_BLUE};
    border-top-left-radius: ${Radius.BLOCK};
    border-top-right-radius: ${Radius.BLOCK};
`;

const StyledModalClose = styled.button`
    appearance: none;
    position: absolute;
    top: 11px;
    right: 13px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 24px;
    height: 24px;
    padding: 5px;
    color: ${Color.WHITE};
    background-color: rgba(255, 255, 255, 0);
    border: none;
    border-radius: ${Radius.BUTTON};
    transition: background-color ${Transition['BUTTON']};

    &:hover,
    &:focus {
        background-color: rgba(255, 255, 255, 0.05);
    }

    &:active {
        background-color: rgba(255, 255, 255, 0.1);
    }
`;

const StyledModalBody = styled.div`
    display: flex;
    flex-direction: column;
    gap: 15px;
    padding: 24px;
`;

export {StyledModal, StyledModalDialog, StyledModalHeader, StyledModalClose, StyledModalBody};
